import { PURCHASE_STATUS_URL } from 'my-purchases/constants/endpoints'
import { useFetch } from 'my-purchases/hooks/useFetch/useFetch'
import { useFormatPrice } from 'my-purchases/hooks/useFormatPrice/useFormatPrice'
import type { NonNormalizedPurchaseStatusDetails } from 'my-purchases/types/purchaseStatus'
import { useMemo } from 'react'
import { useSession } from 'session/src/hooks/useSession'
import useSWRImmutable from 'swr/immutable'
import { url } from 'utils/url'

import { normalizeData } from './normalization'

interface UsePurchaseStatusDetailsProps {
	purchaseId?: string | null
	disabled?: boolean
}

export const usePurchaseStatusDetails = ({
	purchaseId,
	disabled,
}: UsePurchaseStatusDetailsProps) => {
	const { fetcher } = useFetch()
	const { isReady } = useSession()
	const { formatPrice } = useFormatPrice()

	const { data, error, isLoading, mutate } = useSWRImmutable<{
		resolveData: NonNormalizedPurchaseStatusDetails
		status: number
	} | null>(
		!disabled && isReady && purchaseId
			? {
					url: url(`${PURCHASE_STATUS_URL}/${purchaseId}/status`),
					isSecure: false,
				}
			: null,
		fetcher,
		{}
	)

	const purchase = useMemo(() => {
		const { resolveData } = data ?? {}
		return resolveData && normalizeData({ purchase: resolveData, formatPrice })
	}, [data])

	return {
		purchase,
		error,
		isLoading,
		isError: !!error,
		reload: mutate,
	}
}
